var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 19.498L5 18.498C5 18.2219 5.22386 17.998 5.5 17.998L18.5 17.998C18.7761 17.998 19 18.2219 19 18.498L19 19.498C19 19.7742 18.7761 19.998 18.5 19.998L5.5 19.998C5.22386 19.998 5 19.7742 5 19.498ZM17.94 9.14805C17.8459 9.05039 17.7156 8.99608 17.58 8.99805L15 8.99805L15 3.49805C15 3.2219 14.7761 2.99805 14.5 2.99805L9.5 2.99805C9.22386 2.99805 9 3.2219 9 3.49805L9 8.99805L6.42 8.99805C6.28441 8.99608 6.15407 9.05039 6.06 9.14805L5.86 9.34805C5.76534 9.44193 5.7121 9.56973 5.7121 9.70305C5.7121 9.83636 5.76534 9.96416 5.86 10.058L11.65 15.848C11.7407 15.9447 11.8674 15.9996 12 15.9996C12.1326 15.9996 12.2593 15.9447 12.35 15.848L18.14 10.058C18.2347 9.96416 18.2879 9.83637 18.2879 9.70305C18.2879 9.56973 18.2347 9.44193 18.14 9.34805L17.94 9.14805Z",
    fill: "#000000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.fbff5cf6.svg";
export { ForwardRef as ReactComponent };